import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { gtmEventHandler } from '@common/utils/gtm';
import {
  requestParamsSelector,
} from '@alumni_v2/selectors/reviews';
import { Tappable } from '@common/ui/general';
import {
  updateRequestParams,
} from '@alumni_v2/stores/reviews/actions';

import NotFoundIcon from '@alumni_v2/images/svg/not-found.svg';

import styles from './NotFound.module.scss';

function NotFound() {
  const dispatch = useDispatch();

  const requestParams = useSelector(requestParamsSelector) || {};

  const clearFilters = useCallback(() => {
    dispatch(
      updateRequestParams(
        [],
        {},
        null,
      ),
    );
  }, [dispatch]);

  useEffect(() => {
    const quickFilters = requestParams?.quickFilters || [];
    const advancedFilters = requestParams?.advancedFilters || {};

    gtmEventHandler(
      'cta',
      'no_alumni_match',
      'click',
      'alumni_directory',
      {
        click_type: 'no_alumni_match',
        gtm_custom_attributes: {
          pre_academy_segment: advancedFilters.pre_academy_segment_matches_any
          || null,
          post_academy_segment: advancedFilters.post_academy_segment_matches_any
          || null,
          current_role: advancedFilters.pre_scaler_role_matches_any
          || null,
          current_company: advancedFilters.pre_academy_company_matches_any
          || null,
          target_role: advancedFilters.role_matches_any || null,
          target_company: advancedFilters.post_academy_company_matches_any
          || null,
          college: advancedFilters.college_matches_any || null,
          branch: advancedFilters.branch_matches_any || null,
          experience: {
            min: advancedFilters.experience?.[0]?.min ?? null,
            max: advancedFilters.experience?.[0]?.max ?? null,
          },
          salary_hike: {
            min: advancedFilters.growth?.[0]?.min ?? null,
            max: advancedFilters.growth?.[0]?.max ?? null,
          },
          quick_filters: quickFilters || null,
        },
      },
    );
  }, [requestParams]);

  return (
    <div className={styles.container}>
      <img
        src={NotFoundIcon}
        alt="not-found"
        className={styles.img}
      />
      <div
        className={styles.title}
      >
        No matching profiles found. We're working on adding more.
      </div>
      <div
        className={styles.tip}
      >
        Tip:
        {' '}
        {requestParams.search ? 'Try out filters' : 'Try clearing filters'}
      </div>
      <div className={styles.actions}>
        {requestParams.search
          ? (
            <Tappable
              className={`${styles.notify} btn btn-primary`}
              onClick={clearFilters}
            >
              Go Back
            </Tappable>
          )
          : (
            <>
              <Tappable
                className={`${styles.clear} btn btn-secondary`}
                onClick={clearFilters}
              >
                Clear Filters
              </Tappable>
              <Tappable
                href="https://interviewbit.typeform.com/to/YvEjlyPZ"
                className={`${styles.notify} btn btn-primary`}
              >
                Notify Me
              </Tappable>
            </>
          )}
      </div>
      <div className={styles.connect}>
        Do you have any suggestions or
        {' '}
        would you like to have your profile
        {' '}
        listed as an alumni?
        <br />
        Please
        {' '}
        <span>
          <a
            href="mailto:alumni@scaler.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            connect with us!
          </a>
        </span>
      </div>
    </div>
  );
}

export default NotFound;
